import { Injectable } from '@angular/core';
import { CustoEstoqueModel, EstoqueMinimoModel } from '@app/data';
import { ApiService } from '@app/gateway';
import type { DashPeriodQueryPayload } from '@app/pages/dashboard/shared';

@Injectable({ providedIn: 'root' })
export class EstoqueService {
  constructor(protected readonly apiService: ApiService) {}

  public async custoEstoque(data: Pick<DashPeriodQueryPayload, 'idAccounts'>): Promise<CustoEstoqueModel> {
    try {
      const path: string = `estoque/custoEstoque`;
      const result: CustoEstoqueModel = await this.apiService.post({ path, data });
      return result;
    } catch (e: unknown) {
      const message: string = e instanceof Error ? e.message : 'Failed to load stock cost.';
      throw new Error(message, { cause: e });
    }
  }

  public async estoqueMinimo(data: Pick<DashPeriodQueryPayload, 'idAccounts'>): Promise<EstoqueMinimoModel[]> {
    try {
      const path: string = `estoque/estoqueMinimo`;
      const result: EstoqueMinimoModel[] = await this.apiService.post({ path, data });
      return result;
    } catch (e: unknown) {
      const message: string = e instanceof Error ? e.message : 'Failed to load minimum stock.';
      throw new Error(message, { cause: e });
    }
  }
}
